import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	createProjectButtonLabel: {
		id: 'project-picker.create-project-button-label',
		defaultMessage: 'Create project',
		description: 'Label for the button to create a new project within the project picker',
	},
});
